<template>
  <div v-if="error">
    <h4 role="alert" class="sm:text-md text-red leading-tight">
      Unable to calculate quantity, please ensure all input is valid.
    </h4>
  </div>
  <div v-else>
    <h4 class="sm:text-md flex items-center leading-tight">
      {{ title }}
    </h4>
    <p class="sm:text-md font-semibold leading-tight">
      {{ quantity | formatVolume }}
    </p>
  </div>
</template>

<script>
export default {
  name: "CoatingResultsPanel",

  props: {
    error: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    quantity: {
      type: Number,
      required: true,
    },
  },
};
</script>
